<template>
  <div class="divBox">
    <el-card class="box-card">
      <el-form
        ref="formValidate"
        v-loading="fullscreenLoading"
        class="formValidate mt20"
        label-width="160px"
        v-model="formValidate"
        @submit.native.prevent
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="鉴定标题：" prop="appraisal_title">
              <el-input v-model="formValidate.appraisal_title"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="鉴定描述：" prop="appraisal_desc">
              <el-input v-model="formValidate.appraisal_desc"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="鉴定轮播类型：" prop="appraisal_image_type">
              <el-radio-group v-model="formValidate.appraisal_image_type">
                <el-radio :label="1">图片</el-radio>
                <el-radio :label="2">视频</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if = "formValidate.appraisal_image_type == 1">
              <el-form-item label="轮播图片：" prop="appraisal_images">
                <div class="acea-row">
                  <div
                    v-for="(item, index) in formValidate.appraisal_images"
                    :key="index"
                    class="pictrue"
                    draggable="false"
                    @dragstart="handleDragStart($event, item)"
                    @dragover.prevent="handleDragOver($event, item)"
                    @dragenter="handleDragEnter($event, item)"
                    @dragend="handleDragEnd($event, item)"
                  >
                    <img :src="item">
                    <i
                      class="el-icon-error btndel"
                      @click="handleRemove(index)"
                    />
                  </div>
                  <div
                    v-if="formValidate.appraisal_images.length < 10"
                    class="uploadCont"
                    title="750*750px"
                  >
                    <div class="upLoadPicBox" @click="modalPicTap('2')">
                      <div class="upLoad">
                        <i class="el-icon-camera cameraIconfont" />
                      </div>
                    </div>
                  </div>
                </div>
              </el-form-item>
          </el-col>
          <el-col :span="24" v-if = "formValidate.appraisal_image_type == 2">
            <el-form-item label="图片：" prop="appraisal_video_image">
              <div
                class="upLoadPicBox"
                title="750*750px"
                @click="modalPicTap('1')"
              >
                <div v-if="formValidate.appraisal_video_image" class="pictrue">
                  <img :src="formValidate.appraisal_video_image">
                </div>
                <div v-else class="upLoad">
                  <i class="el-icon-camera cameraIconfont" />
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if = "formValidate.appraisal_image_type == 2">
            <el-form-item label="主页视频：" prop="appraisal_video_link">
              <el-input
                v-model="videoLink"
                class="perW50"
                placeholder="请输入视频链接"
              />
              <input
                ref="refid"
                type="file"
                style="display:none"
                @change="zh_uploadFile_change"
              >
              <el-button
                type="primary"
                icon="ios-cloud-upload-outline"
                class="uploadVideo"
                @click="zh_uploadFile"
              >
                {{ videoLink ? "确认添加" : "上传视频" }}
              </el-button>
              <el-col :span="12">
                <el-progress
                  v-if="upload.videoIng"
                  :percentage="progress"
                  :text-inside="true"
                  :stroke-width="20"
                  style="margin-top: 10px;"
                />
              </el-col>
              <el-col :span="24">
                <div v-if="formValidate.appraisal_video_link" class="iview-video-style">
                  <video
                    style="width:100%;height: 100%!important;border-radius: 10px;"
                    :src="formValidate.appraisal_video_link"
                    controls="controls"
                  >
                    您的浏览器不支持 video 标签。
                  </video>
                  <div class="mark" />
                  <i class="el-icon-delete iconv" @click="delVideo" />
                </div>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="鉴定数量：" prop="username">
              <el-input-number :min = 0 v-model="formValidate.appraisal_num"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="ai鉴定收费：" prop="appraisal_ai_price">
              <el-input-number :min = 0 v-model="formValidate.appraisal_ai_price"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="在线鉴定收费：" prop="appraisal_online_price">
              <el-input-number :min = 0 v-model="formValidate.appraisal_online_price"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="实物鉴定收费：" prop="appraisal_offline_price">
              <el-input-number :min = 0 v-model="formValidate.appraisal_offline_price"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="收货联系人：" prop="appraisal_platform_name">
              <el-input  v-model="formValidate.appraisal_platform_name"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="收货联系电话：" prop="appraisal_platform_phone">
              <el-input  v-model="formValidate.appraisal_platform_phone"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="收货省市：" prop="appraisal_platform_city">
              <el-input  v-model="formValidate.appraisal_platform_city"  />
              <span>获取物流价格使用</span>
            </el-form-item>

          </el-col>
          <el-col :span="24">
            <el-form-item label="收货地址：" prop="appraisal_platform_address">
              <el-input  v-model="formValidate.appraisal_platform_address"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="选择鉴别类型：" prop="appraisal_platform_type">
              <el-checkbox-group v-model="formValidate.appraisal_platform_type">
                <el-checkbox v-for="(item,index) in deliveryList" :key="index" :label="index">
                  {{ item }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="margin-top:30px;">
          <el-button :loading="loading" type="primary" class="submission" size="small" @click="handleSubmit()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from '@/settings'
import {
  appraisalConfigDetailApi,
  appraisalConfigPlatformTypeApi,
  appraisalPersonDetailApi, saveAppraisalConfigDataApi,
  saveAppraisalPersonDataApi
} from "@/api/appraisal";
import {productGetTempKeysApi} from "@/api/product";
const defaultObj = {
  appraisal_title: '',
  appraisal_num: 0,
  appraisal_ai_price: 0,
  appraisal_online_price: 0,
  appraisal_offline_price: 0,
  appraisal_platform_address: '',
  appraisal_platform_name: '',
  appraisal_platform_phone: '',
  appraisal_desc: '',
  appraisal_platform_type: [],
  appraisal_images: [],
  appraisal_image_type: 1,
  appraisal_platform_city: ''

}
export default {
  name: 'appraisalConfig',
  data() {
    return {
      roterPre: roterPre,
      fullscreenLoading: false,
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      grid2: {
        xl: 10,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      progress: 0,
      videoLink: '',
      upload: {
        videoIng: false // 是否显示进度条；
      },
      provinceCodeList: [],
      propsMer: { emitPath: true },
      deliveryList: [],
    }
  },
  mounted() {
    this.getPlatformType()
    this.getAppraisalConfig()
  },
  methods: {
    // 点击图
    getPlatformType()
    {
      appraisalConfigPlatformTypeApi()
        .then(res => {
          this.deliveryList =  res.data
          console.log(this.deliveryList)
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.$message.error(res.message)
        })
    },
    // 删除视频；
    delVideo() {
      const that = this
      that.$set(that.formValidate, 'appraisal_video_link', '')
      that.videoLink = '';
      that.progress = 0;
    },
    zh_uploadFile() {
      if (this.videoLink) {
        this.formValidate.appraisal_video_link = this.videoLink
      } else {
        this.$refs.refid.click()
      }
    },
    zh_uploadFile_change(evfile) {
      const that = this
      that.progress = 10
      const suffix = evfile.target.files[0].name.substr(
        evfile.target.files[0].name.indexOf('.')
      )
      if (suffix !== '.mp4') {
        return that.$message.error('只能上传MP4文件')
      }

      productGetTempKeysApi().then(res => {
        that.$videoCloud
          .videoUpload({
            type: res.data.type,
            evfile: evfile,
            res: res,
            uploading(status, progress) {
              that.upload.videoIng = status
            }
          })
          .then(res => {
            that.formValidate.appraisal_video_link = res.url || res.data.src
            that.videoLink = res.url || res.data.src
            that.$message.success('视频上传成功')
            that.progress = 100
          })
          .catch(res => {
            that.upload.videoIng = false
            that.$message.error(res.message)
          })
      })
    },
    // 点击图
    modalPicTap(tit) {
      const _this = this;
      const attr = [];
      this.$modalUpload(function(img) {
        if (tit === "1") {
          _this.formValidate.appraisal_video_image = img[0];
        }
        if (tit === "2") {
          img.map(item => {
            _this.formValidate.appraisal_images.push(item);
            if (_this.formValidate.appraisal_images.length > 10) {
              _this.formValidate.appraisal_images.length = 10;
            }
          });
        }
      }, tit);
    },
    // 移动
    handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move";
    },
    handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = "move";
      if (item === this.dragging) {
        return;
      }
      const newItems = [...this.formValidate.appraisal_images];
      const src = newItems.indexOf(this.dragging);
      const dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));
      this.formValidate.appraisal_images = newItems;
    },
    handleRemove(i) {
      this.formValidate.appraisal_images.splice(i, 1);
    },
    // 获取数据
    getAppraisalConfig() {
      this.fullscreenLoading = true
      appraisalConfigDetailApi(this.$route.params.id)
        .then(res => {
          this.formValidate =  res.data
          if(this.formValidate.appraisal_platform_type.length < 1)
          {
            this.formValidate.appraisal_platform_type = [];
          }
          this.fullscreenLoading = false
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.$message.error(res.message)
        })
    },
    // 提交
    handleSubmit() {
      saveAppraisalConfigDataApi(this.formValidate)
        .then(res => {
          this.fullscreenLoading = false
          this.$message.success(res.message)
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.loading = false
          this.$message.error(res.message)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.label_tip{
  display: inline-block;
  margin-left: 20px;
  color: #C0C4CC;
}
.selWidth {
  width: 100%;
}
.selWidthd {
  width: 300px;
}
.dialog-scustom,.addDia{
  min-width: 400px;
  height: 900px;
  .el-dialog{
    width: 400px;
  }
  h3{
    color: #333;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    margin: 0;
  }
}
.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.agreement{
  width: 350px;
  margin: 0 auto;
  box-shadow: 1px 5px 5px 2px rgba(0,0,0,.2);
  padding: 26px;
  border-radius: 15px;
  .content{
    height: 600px;
    overflow-y:scroll;
    /deep/ p{
      font-size: 13px;
      line-height: 22px;
    }
  }
  /deep/ img{
    max-width: 100%;
  }
  p{
    text-align: justify;
  }
}
/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track{
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
  background-color: transparent;
  border-radius: 3px;
}
.iview-video-style {
  width: 40%;
  height: 180px;
  border-radius: 10px;
  background-color: #707070;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}
.iconv {
  color: #fff;
  line-height: 180px;
  display: inherit;
  font-size: 26px;
  position: absolute;
  top: -74px;
  left: 50%;
  margin-left: -25px;
}
.iview-video-style .mark {
  position: absolute;
  width: 100%;
  height: 30px;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
}
.uploadVideo {
  margin-left: 10px;
}
.perW50 {
  width: 50%;
}
.submission {
  margin-left: 10px;
}
.btndel {
  position: absolute;
  z-index: 1;
  width: 20px !important;
  height: 20px !important;
  left: 46px;
  top: -4px;
}
.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}

</style>
